import { Box, Button, Container } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { useSearchParams } from "react-router-dom";
import CommonDialog from 'src/components/common/CommonDialog';
import FilterSection from 'src/components/common/filterSection'
import AddEditExcerciseMaster from 'src/components/exercise/AddEditExcerciseMaster'
import BulkUploadPracticeList, { downloadSamplePracticeListCsv } from 'src/components/exercise/BulkUploadPracticeList'
import useQueryTable from 'src/hooks/useQueryTable'
import { DeleteExerciseMasterById, GetExerciseMasters } from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetExerciseMasterTableColumns } from 'src/util/columns'

const ExerciseMasterList = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const [recordToEdit, setRecordToEdit] = useState()
  const [customFilterQuery, setCustomFilterQuery] = useState()
  const lessonId = searchParams.get('lessonId');
  const [searchText, setSearchText] = useState(null)
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false)
  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  // get exercise masters API
  // useEffect(() => {
  //   dispatch(GetExerciseMasters())
  // }, [dispatch])

  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'exerciseMasters',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
    additionalFilters: customFilterQuery,
  })

  // set exerciseMasterId in customFilterQuery if present in url params
  useEffect(() => {
    const exerciseMasterId = searchParams.get('_id');
    if (exerciseMasterId) {
      setCustomFilterQuery(prev => ({
        ...prev,
        _id: exerciseMasterId,
      }))
    }
  }, [searchParams]);

  // filter practice list by lessonId
  useEffect(() => {
    setCustomFilterQuery(prev => {
      const updatedQuery = { ...(prev || {}) };

      if (lessonId) {
        updatedQuery.lesson = lessonId;
      } else {
        delete updatedQuery.lesson;
      }

      return updatedQuery;
    });
  }, [lessonId]);


  const onDeleteRow = async recordToDelete => {
    if (recordToDelete) {
      await dispatch(DeleteExerciseMasterById(recordToDelete))
      refetch()
    }
  }

  const columns = useMemo(() => GetExerciseMasterTableColumns(), []);

  return (
    <>
      <Helmet>
        <title>Exercise Masters | Langistan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          {/* addButton filters & search section  */}
          <FilterSection
            type="Practice List"
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
            dispatcher={GetExerciseMasters}
            setCustomFilterQuery={setCustomFilterQuery}
            isViewFilterPanel={lessonId ? false : true}
            secondaryButton={
              <Button variant="outlined" color="primary" onClick={() => setIsBulkUploadOpen(true)}>
                + Bulk Upload
              </Button>
            }
          />

          {/* Exercise Master list */}
          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              toolbarExtra={
                <Button variant="text" size="small" onClick={downloadSamplePracticeListCsv}>
                  Download Sample CSV
                </Button>
              }
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              additionalFilters={customFilterQuery}
              data={data}
              name="practice list"
              exportApiName="exerciseMasters"
              exportFileName="practice-lists.csv"
              isLoading={isLoading}
              isFetching={isFetching}
              setPagination={setPagination}
            />
          </Box>

          {/* Bulk upload practice lists via CSV */}
          <CommonDialog
            open={isBulkUploadOpen}
            title="Bulk Upload Practice Lists"
            onClose={() => setIsBulkUploadOpen(false)}
            maxWidth="sm"
          >
            <BulkUploadPracticeList
              refetch={refetch}
              toggleDrawer={() => setIsBulkUploadOpen(false)}
            />
          </CommonDialog>

          {/* Add & Update practice List */}
          <CommonDialog
            open={!!recordToEdit}
            title={`${Object.keys(recordToEdit ?? {}).length ? "Update" : "Create"} Practice List`}
            onClose={() => {
              setRecordToEdit();
            }
            }
            maxWidth="lg"
          >
            <Box mt={2}>
              <AddEditExcerciseMaster
                selectedRow={recordToEdit}
                toggleDrawer={() => {
                  setRecordToEdit();
                }}
                refetch={refetch}
              />
            </Box>
          </CommonDialog>
        </Container>
      </Box >
    </>
  )
}

export default ExerciseMasterList
